var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":_vm.to}},[_c('v-sheet',{staticClass:"rounded-lg pa-5",staticStyle:{"border":"1px solid #8d8d8d"},attrs:{"color":"#F4F4F4"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }